import { render, staticRenderFns } from "./ModalOBPassword.vue?vue&type=template&id=90153e82&scoped=true&"
import script from "./ModalOBPassword.vue?vue&type=script&lang=ts&"
export * from "./ModalOBPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ModalOBPassword.vue?vue&type=style&index=0&id=90153e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90153e82",
  null
  
)

export default component.exports